/**
 * Global API Lock - Prevents duplicate concurrent API calls
 * Uses localStorage to coordinate across components
 */

const LOCK_TIMEOUT = 30000; // 30 seconds max lock time

export const acquireLock = (key) => {
  const lockKey = `api_lock_${key}`;
  const now = Date.now();
  
  try {
    const existingLock = localStorage.getItem(lockKey);
    if (existingLock) {
      const lockTime = parseInt(existingLock, 10);
      // If lock is old (stale), ignore it
      if (now - lockTime < LOCK_TIMEOUT) {
        console.log(`🔒 Lock "${key}" already held, skipping...`);
        return false;
      }
    }
    
    // Acquire lock
    localStorage.setItem(lockKey, now.toString());
    console.log(`🔓 Lock "${key}" acquired`);
    return true;
  } catch (e) {
    return true; // If localStorage fails, allow the call
  }
};

export const releaseLock = (key) => {
  const lockKey = `api_lock_${key}`;
  try {
    localStorage.removeItem(lockKey);
    console.log(`🔓 Lock "${key}" released`);
  } catch (e) {
    // Ignore
  }
};

// Check if data was recently loaded (within last 5 minutes)
export const wasRecentlyLoaded = (key, maxAgeMs = 300000) => {
  try {
    const cacheTimeKey = `cache_time_${key}`;
    const cachedTime = localStorage.getItem(cacheTimeKey);
    if (cachedTime) {
      const age = Date.now() - parseInt(cachedTime, 10);
      if (age < maxAgeMs) {
        console.log(`✅ "${key}" was loaded ${Math.round(age/1000)}s ago, using cache`);
        return true;
      }
    }
  } catch (e) {
    // Ignore
  }
  return false;
};

export const markAsLoaded = (key) => {
  try {
    const cacheTimeKey = `cache_time_${key}`;
    localStorage.setItem(cacheTimeKey, Date.now().toString());
  } catch (e) {
    // Ignore
  }
};
